export const formatNumber = (() => {
  const { format } = new Intl.NumberFormat('ko-KR');
  return (value?: number | string | null) => format(Number(value ?? 0));
})();
